import React, { useEffect, useRef } from "react";
import { Slider as BlueprintSlider } from "@blueprintjs/core";
import classNames from "classnames";
import { renderNumberValue, getNumberFromNumberString } from "utils/string";
import * as styles from "./styles.module.scss";
const Slider = ({ value, onChange, onUpdateValue, fullSize, classes, min, max, ...restProps }) => {
    const rootRef = useRef(null);
    useEffect(() => {
        const { current } = rootRef;
        if (!current) {
            return;
        }
        const sliderHandle = current.querySelector(".bp5-slider-handle");
        if (!sliderHandle) {
            return;
        }
        const observer = new MutationObserver((records) => {
            const filteredRecords = records.filter(({ attributeName, type }) => type === "attributes" && attributeName === "style");
            if (filteredRecords.length) {
                filteredRecords.forEach(({ target }) => {
                    const targetElement = target;
                    const leftPosition = targetElement.style.left;
                    const [position] = leftPosition.replace(")", "").split("(").pop()?.split(" - ") || [""];
                    if (position) {
                        const numberPosition = +position.replace("%", "");
                        if (numberPosition < 0 || numberPosition > 100) {
                            targetElement.classList.add(styles.hiddenHandle);
                        }
                        else {
                            targetElement.classList.remove(styles.hiddenHandle);
                        }
                    }
                });
            }
        });
        observer.observe(sliderHandle, { attributes: true });
        return () => {
            observer.disconnect();
        };
    }, []);
    return (React.createElement("div", { ref: rootRef, className: classNames(styles.root, classes?.container, { [styles.fullSize]: fullSize }) },
        React.createElement(BlueprintSlider, { className: classNames(styles.slider, classes?.slider, { [styles.sliderFullSize]: fullSize }), value: getNumberFromNumberString(value ?? "") ?? min, labelRenderer: false, onChange: (sliderValue) => onChange(renderNumberValue(sliderValue)), onRelease: onUpdateValue, min: min, max: max, ...restProps })));
};
export default Slider;
